/** @jsx jsx */
import { Dialog } from '@datacamp/waffles/dialog';
import { Database } from '@datacamp/waffles/icon';
import { Link } from '@datacamp/waffles/link';
import { Paragraph } from '@datacamp/waffles/paragraph';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useSelector } from '../../interfaces/State';
import { selectCourseDatasets } from '../../redux/selectors/course';

import GuidesBackButton from './GuidesBackButton';

const DownloadDatasetsModal: React.FC = () => {
  const { t } = useTranslation();
  const datasets = useSelector(selectCourseDatasets);
  if (datasets.isEmpty()) {
    return (
      <>
        <Dialog.Header>{t('DownloadDatasetsModal.header')}</Dialog.Header>
        <Dialog.Body>
          <Paragraph>{t('DownloadDatasetsModal.emptyText')}</Paragraph>
        </Dialog.Body>
      </>
    );
  }
  return (
    <>
      <Dialog.Header>{t('DownloadDatasetsModal.header')}</Dialog.Header>
      <Dialog.Body>
        <ul
          css={{
            margin: 0,
            padding: 0,
            listStyle: 'none',
          }}
        >
          {datasets.map((dataset, index) => (
            <li
              key={`dataset-${index}`}
              css={{
                marginBottom: tokens.spacing.small,
              }}
            >
              <Link
                size="medium"
                iconLeft={<Database />}
                href={dataset.get('asset_url')}
              >
                {dataset.get('name')}
              </Link>
            </li>
          ))}
        </ul>
      </Dialog.Body>
      <Dialog.Footer>
        <GuidesBackButton />
      </Dialog.Footer>
    </>
  );
};

export default DownloadDatasetsModal;
